import { useTheme } from "@mui/material";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

import { Divider } from "@/Components/v2/atoms/Divider";
import { Stack } from "@/Components/v2/atoms/Stack";

import {
  ChartToggle,
  RevenueDataPoint,
  ROIDataPoint,
  TotalSpendDataPoint,
} from "@/pages/flighting/types/common";
import ROIChart from "@/pages/flighting/components/Chart/ROIChart";
import ROIToggle from "@/pages/flighting/components/ROIToggle";
import { Typography } from "@/Components/v2/atoms/Typography";
import RevenueToggle from "@/pages/flighting/components/RevenueToggle";
import { useFlightingStore } from "@/pages/flighting/store/useFlightingStore";
import { isEmpty } from "lodash";
import { BoldSpan } from "@/Components/v2/atoms/Typography/BoldSpan";

dayjs.extend(isSameOrAfter);

interface BreakdownProps {
  roiData: ROIDataPoint[];
  revenueData: RevenueDataPoint[];
  totalSpendGraphData: TotalSpendDataPoint[];
}

const Breakdown: React.FC<BreakdownProps> = ({ roiData, revenueData, totalSpendGraphData }) => {
  const theme = useTheme();
  const chartToggles = useFlightingStore((state) => state.chart.toggles);
  const isROIToggleSelected = chartToggles.includes(ChartToggle.ROI);

  return (
    <Stack
      border={`1px solid ${theme.palette.section.border}`}
      borderRadius={4}
      marginY={2}
      padding={4}
      paddingY={3}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight={600} fontSize={24}>
          Flighting
        </Typography>
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
          <RevenueToggle />
        </Stack>
      </Stack>
      <Divider />
      {isROIToggleSelected && (
        <Stack direction="row" justifyContent="end" alignItems="center" spacing={1} mt={3}>
          <ROIToggle />
        </Stack>
      )}
      <Stack marginTop={4}>
        {isEmpty(chartToggles) ? (
          <Typography fontSize={14}>
            <BoldSpan>No view selected.</BoldSpan> Choose Spend, Revenue, or ROI to explore your
            media flighting.
          </Typography>
        ) : (
          <ROIChart
            roiData={roiData}
            revenueData={revenueData}
            totalSpendData={totalSpendGraphData}
            toggles={chartToggles}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default Breakdown;
